export const requiredFields =
    process.env.REACT_APP_COMMERCIAL_CRM_FIELDS_BASE_BP?.split(',') || [
        'apellidos',
        'ciudadResidencia',
        'email1',
        'email2',
        'nombres',
        'numIdentificacion',
        'telefonoFijo',
        'telefonoMovil',
        'tipoDocumento',
    ];
